<template>
  <div class="bdy_top">
    <!-- <el-button type="text" @click="dialogFormVisible = true">打开嵌套表单的 Dialog</el-button> -->
    <div class="table_list">
      <div class="table_list_button">
        <h1>餐时管理</h1>
        <!-- <el-button type="primary" style="background:#1890ff;" >
          <i class="el-icon-plus" style="margin-right:10px"></i>
          新增
        </el-button> -->
      </div>
      <el-table
        :fit="false"
        border
        :data="tableData"
        :cell-style="() => 'text-align: center;'"
        :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
      >
        <template slot="empty">
          <noCart></noCart>
        </template>
        <el-table-column label="餐点名称">
          <template slot-scope="scope">
            <span>{{ scope.row.date }}</span>
          </template>
        </el-table-column>
        <el-table-column label="开始时间">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="结束时间">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="收货地址" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="活动名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动区域" :label-width="formLabelWidth">
          <el-select v-model="form.region" placeholder="请选择活动区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogForm(false)">取 消</el-button>
        <el-button type="primary" @click="dialogForm(false)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  range as rangeArr,
  getFirstDayOfMonth,
  getPrevMonthLastDays,
  getMonthDays,
} from 'element-ui/src/utils/date-util';
import fecha from 'element-ui/src/utils/date';
export default {
  name: 'shop',
  components: {},
  data() {
    return {
      names: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      rowS: [],
      row: [],
      dataName: {
        startDate: '',
        endDate: '',
      },
      huodongtest: [
        {
          date: '2020-05-11',
          dates: '2020-05-15',
          name: '测试测试',
          color: '#f00',
        },
        {
          date: '2020-05-11',
          dates: '2020-05-20',
          name: '测试测试',
          color: '#00f',
        },
        {
          date: '2020-05-11',
          dates: '2020-05-30',
          name: '测试测试',
          color: '#0ff',
        },
        {
          date: '2020-05-11',
          dates: '2020-05-13',
          name: '测试测试',
          color: '#ff0',
        },
      ],
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      tableData: []
    };
  },

  methods: {
    rows() {
      let days = [];
      // if range exists, should render days in range.
      const date = new Date();
      this.date = date;
      // 获取当月第一天
      const firstDay = getFirstDayOfMonth(date);
      // 根据当月第一天计算当月中上个月显示几天
      const prevMonthDays = getPrevMonthLastDays(date, firstDay - 1).map(
        (day) => ({
          text: day,
          type: 'prev',
          prefix: this.prevMonthDatePrefix(),
        })
      );
      // 获取本月多少天
      const currentMonthDays = getMonthDays(date).map((day) => ({
        text: day,
        type: 'current',
        prefix: this.curMonthDatePrefix(),
      }));
      days = [...prevMonthDays, ...currentMonthDays];
      // 日历一共6行每周7天共42天,42-上个月-本月=下月天数
      const nextMonthDays = rangeArr(42 - days.length).map((_, index) => ({
        text: index + 1,
        type: 'next',
        prefix: this.nextMonthDatePrefix(),
      }));
      // 连起来共多少天
      days = days.concat(nextMonthDays);
      this.huodongtest.filter((items) => {
        const start = new Date(items.date).getTime();
        const end = new Date(items.dates).getTime();
        days.map((item) => {
          const da = new Date(item.prefix + '-' + item.text).getTime();
          if (da >= start && da <= end) {
            let dv = {
              zhanshi: false,
              leftClass: false,
              rightClass: false,
              ...items,
            };
            if (da == start) {
              dv.zhanshi = true;
              dv.leftClass = true;
            } else if (da == end) {
              dv.rightClass = true;
            }

            if (!item.children) {
              item.children = [dv];
            } else {
              item.children.push(dv);
            }
          }
        });
      });
      days.map((item) => {
        if (item.children) {
          let data = {};
          let arr = [];
          item.children.map((items) => {
            const start = new Date(items.date).getTime();
            const end = new Date(items.dates).getTime();
            const size = end - start;
            data[size] = items;
            arr.push(size);
            return items;
          });
          var max;
          for (var i = 0; i < arr.length; i++) {
            for (var j = i; j < arr.length; j++) {
              if (arr[i] < arr[j]) {
                max = arr[j];
                arr[j] = arr[i];
                arr[i] = max;
              }
            }
          }
          item.children = arr.map((item) => data[item]);
        }
        return item;
      });
      this.row = days;
      this.rowS = this.toNestedArr(days);
      console.log(this.rowS);
    },
    // 本月分割成7个数组,赋给rows,动态渲染
    toNestedArr(days) {
      return rangeArr(days.length / 7).map((_, index) => {
        const start = index * 7;
        return days.slice(start, start + 7);
      });
    },
    dateClick(value) {
      const { text, type, prefix } = value;
      if (this.dataName.startDate === '') {
        if (type === 'current') {
          this.row = this.row.map((item) => {
            if (item.text === text && item.prefix === prefix) {
              item.type = 'clickDate';
            } else if (item.type !== 'prev' && item.type !== 'next') {
              item.type = 'current';
            }
            return item;
          });
          this.dataName.startDate = prefix + '-' + text;
          this.rowS = this.toNestedArr(this.row);
        }
      } else if (this.dataName.endDate === '') {
        if (type === 'current' || type === 'clickDate') {
          this.dataName.endDate = prefix + '-' + text;
          let start = new Date(this.dataName.startDate).getTime();
          let end = new Date(this.dataName.endDate).getTime();
          if (end < start) {
            const a = this.dataName.startDate;
            const b = this.dataName.endDate;
            this.dataName.endDate = a;
            this.dataName.startDate = b;
            start = new Date(this.dataName.startDate).getTime();
            end = new Date(this.dataName.endDate).getTime();
          }
          this.row = this.row.map((item) => {
            const dae = new Date(item.prefix + '-' + item.text).getTime();
            if (dae >= start && dae <= end) {
              item.type = 'clickDate';
            }
            return item;
          });
          this.rowS = this.toNestedArr(this.row);
          this.dialogForm(true, value);
        }
      } else {
        this.dataName.startDate = '';
        this.dataName.endDate = '';
        this.rows();
      }
      console.log(this.dataName);
    },

    getFormateDate(day, type) {
      if (!day || ['prev', 'current', 'next'].indexOf(type) === -1) {
        throw new Error('invalid day or type');
      }
      let prefix = this.curMonthDatePrefix();
      console.log(prefix);
      if (type === 'prev') {
        prefix = this.prevMonthDatePrefix();
      } else if (type === 'next') {
        prefix = this.nextMonthDatePrefix();
      }
      day = `00${day}`.slice(-2);
      console.log(day, '/????');
      return `${prefix}-${day}`;
    },
    prevMonthDatePrefix() {
      const temp = new Date(this.date.getTime());
      console.log(temp);
      temp.setDate(0);
      return fecha.format(temp, 'yyyy-MM');
    },

    curMonthDatePrefix() {
      return fecha.format(this.date, 'yyyy-MM');
    },

    nextMonthDatePrefix() {
      const temp = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        1
      );
      return fecha.format(temp, 'yyyy-MM');
    },
    open(value) {
      this.$prompt('请输入邮箱', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确',
      })
        .then(({ value }) => {
          this.$message({
            type: 'success',
            message: '你的邮箱是: ' + value,
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          });
          this.dateClick(value);
        });
    },
    dialogForm(lien) {
      this.dialogFormVisible = lien;
      if (!lien) {
        this.dataName.startDate = '';
        this.dataName.endDate = '';
        this.rows();
      }
    },
    dialogForms() {
      console.log(111);
    },
  },

  created() {
    this.rows();
  },
};
</script>
<style scoped>
.bdy_top {
  width: 100%;
  height: auto;
}

.rili {
  width: 100%;
  height: auto;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
  font-size: 14px;
}
.rili .ul {
  width: 100%;
  border-top: solid 1px #eee;
  display: flex;
  justify-content: space-between;
  border-left: solid 1px #eee;
}
.rili .ul li {
  flex: 1;
  border-right: solid 1px #eee;
  min-height: 77px;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 10px;
  padding-top: 30px;
}
.rili .ul li span {
  position: absolute;
  right: 10px;
  top: 5px;
}
.rili .ul:last-child li {
  border-bottom: solid 1px #eee;
}
.back_r {
  display: flex;
}
.back_r li {
  flex: 1;
  text-align: end;
}
.prev,
.next {
  color: #c0c4cc;
}
.clickDate {
  background: #f2f8fe;
  color: #409eff;
}
.ceshi {
  flex: 1;
  height: 20px;
  opacity: 0.5;
  text-align: center;
}
.leftClass {
  box-sizing: border-box;
  margin-left: 10px;
  border-radius: 5px 0 0 5px;
}
.rightClass {
  box-sizing: border-box;
  margin-right: 10px;
  border-radius: 0 5px 5px 0;
}
.table_list {
  width: 100%;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  padding: 20px;
}
.table_list_button {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.el-table__body,
.el-table__header {
  width: 100% !important;
}
table,
tbody,
thead {
  width: 100% !important;
}
colgroup {
  position: absolute;
  width: 100% !important;
  display: flex;
}
col {
  flex: 1;
  text-align: center;
}
</style>
